export default "__VITE_ASSET__a4f7713a__"